module.exports = __webpack_public_path__ + "static/media/5071.954bae4c.jpg";